module.exports = "data:text/markdown;base64,IyMjIENhbGxiYWNrIENhbGxzOgpBbiBpbmJvdW5kIGNhbGwgZnJvbSBhIHByb3NwZWN0IHdlIGhhdmUgcHJldmlvdXNseSBjYWxsZWQuCg=="